import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FallbackField = ({
  fallbackValue,
  onFallbackChange,
  isGlobalFallback,
  onIsGlobalFallbackChange,
  settingsLink,
  showGlobalFallbackCheckbox,
  handleConfirm
}) => {
  const globalFallbackCheckbox = /*#__PURE__*/_jsx(UICheckbox, {
    size: "small",
    className: "p-top-2",
    checked: !!isGlobalFallback,
    onChange: ({
      target: {
        checked
      }
    }) => onIsGlobalFallbackChange(checked),
    "data-test-id": "default-value-global-checkbox",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      options: {
        href: settingsLink
      },
      message: "data-token-picker.fallbackLabelHelp"
    })
  });
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleConfirm();
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "data-token-picker.fallbackLabel"
      }),
      children: /*#__PURE__*/_jsx(UITextInput, {
        "data-test-id": "local-fallback-input",
        value: fallbackValue || '',
        disabled: showGlobalFallbackCheckbox && isGlobalFallback,
        onChange: ({
          target: {
            value
          }
        }) => onFallbackChange(value),
        onKeyDown: handleKeyDown
      })
    }), showGlobalFallbackCheckbox && globalFallbackCheckbox]
  });
};
FallbackField.displayName = 'FallbackField';
export default FallbackField;